// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"691":"stripe-express","700":"shop-chat"}[chunkId] + "." + {"691":"79f77787","700":"042bc42e"}[chunkId] + ".js";
};